import React from "react";
import { Col, Row } from "react-bootstrap";
import TextField from "@mui/material/TextField";
import { Calendar } from 'primereact/calendar';
import { InputNumber } from "primereact/inputnumber";
import Switch from "@mui/material/Switch";
import FormControlLabel from "@mui/material/FormControlLabel";
import Langs, { Localize } from "../../../app/lang/langs";
import styles from '../VcompCompnents.module.css';
import addImageIcon from '../../../assets/images/addProjectImage.png';
import deleteImageIcone from '../../../assets/images/deleteImageIcon.png';
import ImageButton from "../../buttons/ImageButton";
import { ThemeButton } from '../../buttons/ThemeButton';
import TabNavigationButtons from "./TabNavigationButtons";

/**
 * ProjectDetailsTab - Renders the project details form (case 0).
 * Includes image upload, project name, dates, delay, status toggle, and nav buttons.
 *
 * All state and handlers are passed in from the parent to preserve the existing data flow.
 */
export default function ProjectDetailsTab({
    project,
    validFields,
    mode,
    isMobile,
    fileInputRef,
    // handlers
    onImageChange,
    onImageClick,
    onDeleteImage,
    onDragOver,
    onDrop,
    onProjectNameChange,
    onDateChangeStart,
    onDateChangeEnd,
    onDelayChange,
    onNeededCollabsChange,
    onActiveChange,
    onSave,
    checkStartDateValidity,
}) {
    return (
        <div className={styles.tabFadeIn}>
            <div className={styles.modalTabCard}>
                <Row className="p-2 m-3">
                    <Col lg={12} className="d-flex justify-content-center" style={{ height: "200px" }}>
                        <div className={styles.imageUploadContainer}
                            onDragOver={onDragOver}
                            onDrop={onDrop}
                            onClick={() => !project.image_src && onImageClick()}
                        >
                            <input
                                type="file"
                                accept="image/*"
                                onChange={onImageChange}
                                ref={fileInputRef}
                                style={{ display: 'none' }} />
                            <div className={styles.imageContainer}>
                                {project.image_src &&
                                    <img
                                        src={project.image_src ? project.image_src : addImageIcon}
                                        alt="Click to upload"
                                        onClick={onImageClick}
                                        className={project.image_src ? styles.addImageBlock : styles.addImageBlockIcon} />}
                                {!project.image_src && isMobile !== 2 &&
                                    <span className={styles.spanImageContainer}>
                                        <Langs str='DRAG_DROP_IMAGE' />
                                    </span>}
                                {!project.image_src && isMobile === 2 &&
                                    <span className={styles.spanImageContainer}>
                                        <Langs str='ADD_IMAGE' />
                                    </span>}
                                {project.image_src && (
                                    <div className={styles.deleteButton}>
                                        <ImageButton
                                            onClick={onDeleteImage}
                                            image={deleteImageIcone}
                                            imageFocus={deleteImageIcone}
                                            active={true}
                                            width={38} />
                                    </div>
                                )}
                            </div>
                        </div>
                    </Col>
                </Row>
                <Row className="p-2 m-3">
                    <Col lg={12}>
                        <TextField
                            error={!validFields.nom && validFields.tried}
                            slotProps={{ htmlInput: { maxLength: 250 } }}
                            fullWidth
                            id="project-name"
                            label={<Langs str='PROJECT_NAME' />}
                            value={project.nom}
                            onChange={(e) => onProjectNameChange(e)}
                            variant="outlined"
                            size="small"
                        />
                    </Col>
                </Row>
                <Row className="p-2 m-3">
                    <Col lg={6} className="d-flex justify-content-start">
                        <div className="p-float-label">
                            <Calendar dateFormat="dd/mm/yy" invalid={!validFields.start_date && validFields.tried}
                                id="project-date"
                                value={project.start_date}
                                disabled={checkStartDateValidity()}
                                onChange={(e) => onDateChangeStart(e)} />
                            <label htmlFor="project-date"><Langs str='START_DATE' /></label>
                        </div>
                    </Col>
                    <Col lg={6} className={isMobile == 2 ? " mt-3" : "d-flex justify-content-end"}>
                        <div className="p-float-label">
                            <Calendar minDate={project.start_date} disabled={!project.start_date} dateFormat="dd/mm/yy" id="project-date-end" value={project.end_date} onChange={(e) => onDateChangeEnd(e)} />
                            <label htmlFor="project-date-end"><Langs str='END_DATE' /></label>
                        </div>
                    </Col>
                </Row>
                <Row className="p-2 m-3">
                    <Col lg={6} className="d-flex justify-content-start">
                        <div className="p-float-label">
                            <InputNumber
                                inputId="project-delay"
                                value={project.days_limit}
                                onValueChange={(e) => onDelayChange(e)}
                                showButtons
                                buttonLayout="horizontal"
                                step={1}
                                min={1}
                                allowEmpty={false}
                                inputStyle={{ width: "6rem", textAlign: "center" }}
                                decrementButtonClassName={`p-button-warning `}
                                incrementButtonClassName="p-button-warning"
                                incrementButtonIcon="pi pi-plus"
                                decrementButtonIcon="pi pi-minus" />
                            <label htmlFor="project-delay"><Langs str='DELAY_WEEKS' /><Langs />
                            </label>
                        </div>
                    </Col>
                    {isMobile === 1 && (
                        <Col lg={6} className="d-flex justify-content-end">
                        </Col>
                    )}
                </Row>
                {mode != "edit" && !project.id && (
                    <Row className="p-2 m-3">
                        <Col lg={6} className="d-flex justify-content-start">
                            <div className="p-float-label">
                                <InputNumber
                                    inputId="project-needed-collabs"
                                    value={project.needed_collabs}
                                    onValueChange={(e) => onNeededCollabsChange(e)}
                                    showButtons
                                    buttonLayout="horizontal"
                                    step={1}
                                    min={0}
                                    allowEmpty={false}
                                    inputStyle={{ width: "6rem", textAlign: "center" }}
                                    decrementButtonClassName={`p-button-warning `}
                                    incrementButtonClassName="p-button-warning"
                                    incrementButtonIcon="pi pi-plus"
                                    decrementButtonIcon="pi pi-minus" />
                                <label htmlFor="project-needed-collabs"><Langs str='NEEDED_COLLABS_NUMBER' /><Langs />
                                </label>
                            </div>
                        </Col>
                        {isMobile === 1 && (
                            <Col lg={6} className="d-flex justify-content-end">
                            </Col>
                        )}
                    </Row>
                )}
                <Row className="p-2 m-3 justify-content-end align-items-center">
                    <Col xs={9}>
                        <span className={styles.statusLabel}><Langs str="PROJECT_STATUS" /></span>
                    </Col>
                    <Col xs={3}>
                        <FormControlLabel
                            control={
                                <Switch
                                    checked={project.active == true}
                                    onChange={(e) => { onActiveChange(e.target.checked) }}
                                    color="warning"
                                />
                            }
                            label={project.active ? Localize("Active") : Localize("Inactive")}
                        />
                    </Col>
                </Row>
                {isMobile === 2 && (
                    <Row className="mt-3 d-flex justify-content-center" style={{ width: '100%' }}>
                        <Col xs={6} className="d-flex justify-content-center">
                            <ThemeButton title={mode == "edit" ? <Langs str="SAVE" /> : <Langs str="Next" />} active={true} onClick={onSave} style={{ width: '48%' }} />
                        </Col>
                    </Row>
                )}
            </div>
            {isMobile !== 2 && (
                <div>
                    <div style={{
                        position: 'fixed',
                        bottom: '1.5rem',
                        right: isMobile === 3 ? '3rem' : '1.5rem',
                        width: isMobile === 3 ? '15%' : '7%'
                    }}>
                        <ThemeButton
                            title={mode === "edit" ? <Langs str="SAVE" /> : <Langs str="Next" />}
                            active={true}
                            onClick={onSave}
                            style={{ width: '100%' }}
                        />
                    </div>
                </div>
            )}
        </div>
    );
}
